import axios from 'axios';
import url from '@/url';

export const getAllMessages = async () => {
  try {
    const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.admin_messages, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    // Debug: Log the response structure
    console.log('Admin messages response:', response.data);
    
    // Response format: { result: { status: 200, mesEn: '...', mesAr: '...', data: [...] } }
    if (response.data?.result?.status === 200) {
      return response.data.result.data || [];
    }
    return [];
  } catch (error) {
    console.error('Error fetching all messages:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const getActiveMessages = async () => {
  try {
    const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.admin_messages_active, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    // Debug: Log the response structure
    console.log('Active messages response:', response.data);
    
    // Response format: { result: { status: 200, mesEn: '...', mesAr: '...', data: [...] } }
    if (response.data?.result?.status === 200) {
      return response.data.result.data || [];
    }
    return [];
  } catch (error) {
    console.error('Error fetching active messages:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const getWelcomeMessage = async () => {
  try {
    const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.admin_messages_welcome, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    // Debug: Log the response structure
    console.log('Welcome message response:', response.data);
    
    // Response format: { result: { status: 200, mesEn: '...', mesAr: '...', data: {...} } }
    if (response.data?.result?.status === 200) {
      const messageData = response.data.result.data;
      // Check if response has data (not empty)
      if (messageData && Object.keys(messageData).length > 0) {
        return messageData;
      }
    }
    console.log('No welcome message found');
    return null;
  } catch (error) {
    // Handle 404 gracefully - endpoint might not exist yet
    if (error.response?.status === 404) {
      console.log('Welcome message endpoint not found (404)');
      return null;
    }
    console.error('Error fetching welcome message:', error);
    console.error('Error response:', error.response?.data);
    return null;
  }
};

export const createMessage = async (messageData) => {
  try {
    const response = await axios.post(process.env.VUE_APP_SERVICE_URL + url.admin_messages, messageData, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    // Debug: Log the response structure
    console.log('Create message response:', response.data);
    
    // Response format: { result: { status: 200, mesEn: '...', mesAr: '...', data: {...} } }
    if (response.data?.result?.status === 200) {
      return response.data.result.data;
    }
    throw new Error('Failed to create message');
  } catch (error) {
    console.error('Error creating message:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const updateMessage = async (messageId, messageData) => {
  try {
    const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.admin_messages + `/${messageId}`, messageData, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    // Debug: Log the response structure
    console.log('Update message response:', response.data);
    
    // Response format: { result: { status: 200, mesEn: '...', mesAr: '...', data: {...} } }
    if (response.data?.result?.status === 200) {
      return response.data.result.data;
    }
    throw new Error('Failed to update message');
  } catch (error) {
    console.error('Error updating message:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const deleteMessage = async (messageId) => {
  try {
    await axios.delete(process.env.VUE_APP_SERVICE_URL + url.admin_messages + `/${messageId}`, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    return true;
  } catch (error) {
    console.error('Error deleting message:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const toggleMessageStatus = async (messageId) => {
  try {
    await axios.patch(process.env.VUE_APP_SERVICE_URL + url.admin_messages + `/${messageId}/toggle`, null, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    return true;
  } catch (error) {
    console.error('Error toggling message status:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
}; 